const getEntities = (list, addToList, userId = null) => {
	list.forEach((item) => {
		if (item?.isEnabled) {
			if (userId === null) addToList([item]);
			if (item.entityAdmins.some((admins) => admins.userId === userId)) addToList([item]);
		}
		if (item?.nodes?.length > 0) getEntities(item.nodes, addToList, userId);
	});
};

const mapEntities = ({label, id, entityId, entityAdmins, contacts}) => ({
	label,
	value: id,
	id,
	entityId,
	entityAdmins,
	selected: false,
	disabled: false,
	contacts
});

const getAvailableEntityList = (list, mapped = true, userId = null) => {
	const newList = [];
	const addToList = (itemsToAdd) => newList.push(...itemsToAdd);
	getEntities(list, addToList, userId);
	return mapped ? newList.map(mapEntities) : newList;
};

export const getEntityIndeterminateState = (list, selectedUsers) => {
	const result = [];
	list.forEach((item) => {
		// Filter selected users from the entity
		const selectedFromEntity = item.contacts?.filter(({userId}) =>
			selectedUsers.some((selected) => userId === selected.userId)
		);

		// All selected users are in this entity so it should be checked
		if (selectedFromEntity.length === selectedUsers.length) {
			result.push({...item, selected: false, checked: true, indeterminate: false});
			return;
		}

		// Some selected users are in this entity so it should be indetermined
		if (selectedFromEntity.length > 0) {
			result.push({...item, selected: false, checked: false, indeterminate: true});
			return;
		}
	});
	return result;
};

export const getAdminAvailableEntityList = (list, userId) => {
	return getAvailableEntityList(list, true, userId);
};

export default getAvailableEntityList;
